import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_GROWTH_MEMBERSHIP_ROUTING_UPDATE = createFcmDetails('growth_membership_routing_update', {
	owner: 'Revenue',
	context: 'Post Sign Flow (Membership Ask + Share)',
	description: `
		This configuration enables the Membership Ask + Share experience on the Post-Signature Flow (PSF) for petitions where promotions are turned off.

		This allows us to continue capturing revenue from highly viral petitions that do not conform to our individual petition policy rules.
	`,
	import: false,
});
